import { Insurance } from '../../lib/types/models/insurance/insurance'
import { InsuranceInput } from '../../lib/types/models/insurance/insurance-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createInsurance(data: InsuranceInput) {
  return restApiClient
    .url(constructApiUrl(API.insurances.create.url, null))
    .post<Insurance, InsuranceInput>(data)
}
